import { NgModule } from '@angular/core';
import { Routes, RouterModule, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DefaultComponent } from './layouts/default/default.component';
import { HomeComponent } from './modules/home/home.component';
import { PageComponent } from './layouts/page/page.component';
import { CoursesComponent } from './modules/courses/courses.component';
import { CourseComponent } from './modules/course/course.component';
import { FullwidthComponent } from './layouts/fullwidth/fullwidth.component';
import { LoginComponent } from './modules/login/login.component';
import { RegisterComponent } from './modules/register/register.component';
import { MyAccountComponent } from './layouts/my-account/my-account.component';
import { AccountDashboardComponent } from './modules/account-dashboard/account-dashboard.component';
import { MyCoursesComponent } from './modules/my-courses/my-courses.component';
import { CheckoutComponent } from './modules/checkout/checkout.component';
import { MyCourseComponent } from './modules/my-course/my-course.component';
import { CourseResolver } from './resolvers/course-resolver';
import { PageNotFoundComponent } from './modules/page-not-found/page-not-found.component';
import { EnglishCoursesComponent } from './modules/english-courses/english-courses.component';
import { EnglishCourseComponent } from './modules/english-course/english-course.component';
import { AuthGuardService } from './guards/auth-guard.service';
import { VerifyEmailComponent } from './modules/verify-email/verify-email.component';
import { OtherPageComponent } from './modules/other-page/other-page.component';
import { HomeResolver } from './resolvers/home-resolver';
import { InstructorsComponent } from './modules/instructors/instructors.component';
import { ContactComponent } from './modules/contact/contact.component';
import { InstructorComponent } from './modules/instructor/instructor.component';
import { KnowledgeComponent } from './modules/knowledge/knowledge.component';
import { KnowledgesComponent } from './modules/knowledges/knowledges.component';
import { PartnersComponent } from './modules/partners/partners.component';
import { FbRegisterComponent } from './modules/fb-register/fb-register.component';
import { TeacherCommentsComponent } from './modules/teacher-comments/teacher-comments.component';
import { ForgotPasswordComponent } from './modules/forgot-password/forgot-password.component';
import { UpdatePhotoComponent } from './modules/update-photo/update-photo.component';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { DictionaryComponent } from './modules/dictionary/dictionary.component';



const routes: Routes = [
  {
    path:'',
    component:DefaultComponent,
    children:[
      {
        path:'',
        component:HomeComponent,
        // resolve:{
        //   homeData:HomeResolver
        // }
      }
    ]
  },
  {
    path:'',
    component:PageComponent,
    children:[
      {
        path:'courses',
        component:CoursesComponent
      },
      {
        path:'course/:id',
        component:CourseComponent
      },
      {
        path:'my-account',
        component:MyAccountComponent,
        canActivate:[AuthGuardService],
        children:[
          {
            path:'dashboard',
            component:AccountDashboardComponent
          },
          {
            path:'courses',
            component:MyCoursesComponent
          },
          {
            path:'teacher-comments',
            component:TeacherCommentsComponent
          }
        ]
      },
      {
        path:'checkout/:courseId',
        component:CheckoutComponent,
        canActivate:[AuthGuardService]
      },
      {
        path:'my-course/:id',
        component:MyCourseComponent,
        resolve:{
          coursePass:CourseResolver
        }
      },
      {
        path:"not-found",
        component:PageNotFoundComponent
      },
      {
        path:'lessons',
        component:EnglishCoursesComponent
      },
      
      {
        path:'lessons/:id',
        component:EnglishCourseComponent
      },
      {
        path:'other/:pageId',
        component:OtherPageComponent
      },
      {
        path:'instructors',
        component:InstructorsComponent
      },
      {
        path:"instructor/:id",
        component:InstructorComponent
      },
      {
        path:'knowledges',
        component:KnowledgesComponent
      },
      {
        path:'knowledge/:id',
        component:KnowledgeComponent
      },
      {
        path:'partners',
        component:PartnersComponent
      },
      {
        path:'contact',
        component:ContactComponent
      },
      {
        path:'phrasalverbs',
        component:DictionaryComponent
      }
    ]
  },
  {
    path:'',
    component:FullwidthComponent,
    children:[
      {
        path:'login',
        component:LoginComponent
      },
      {
        path:'register',
        component:RegisterComponent
      },
      {
        path:'verify-email',
        component:VerifyEmailComponent
      },
      {
        path:'fb-register',
        component:FbRegisterComponent
      },
      {
        path:'forgot-password',
        component:ForgotPasswordComponent
      },
      {
        path:'update-photo',
        component:UpdatePhotoComponent
      }
    ]
  },
  {
		path: "**",
		redirectTo: "/"
	}
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, initialNavigation: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
